import { render } from "./ValidationProvider.vue?vue&type=template&id=2d208210"
import script from "./ValidationProvider.vue?vue&type=script&lang=js"
export * from "./ValidationProvider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__